<!-- BEGIN: Left Aside -->
<button class="m-aside-left-close  m-aside-left-close--skin-dark" id="m_aside_left_close_btn" appunwraptag="">
  <i class="la la-close"></i>
</button>
<div id="m_aside_left" class="m-grid__item	m-aside-left  m-aside-left--skin-dark">
  <!-- BEGIN: Aside Menu -->
  <div id="m_ver_menu" class="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark" m-menu-vertical="1" m-menu-scrollable="1"
    m-menu-dropdown-timeout="500" style="position: relative;">
    <ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow">
      <li class="m-menu__section">
        <div class="m-card-user m-card-user--skin-dark">
          <div class="m-card-user__pic">
            <img alt="" class="m--img-rounded m--marginless" src="{{lib.imageUrl(userInfo.UserImageUrl)}}" [type]="'user-img'">
          </div>
          <div class="m-card-user__details">
            <label class="m-card-user__name m--font-weight-500">
              {{userInfo?.Fullname}}
            </label>
            <label class="m-card-user__name m--font-weight-500" style="font-size: 10px">
              ({{userInfo?.RoleName}})
            </label>
          </div>
        </div>

        <div class="m-card-user m-card-user--skin-dark">
          <div class="m-card-user__details no-padding">
            <a class="m-card-user__name m--font-weight-300" style="font-size: 10px">Licenced To :
              <strong>{{companyInfo?.CompanyName}}</strong>
            </a>
          </div>
        </div>
      </li>
      <!-- DO NOT ADD ANY KIND OF MENU IN THIS PAGE -->

      <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: lstMenu }"></ng-container>
      <ng-template #recursiveList let-lstData>
        <ng-template ngFor let-item [ngForOf]="lstData">
          <ng-container *ngIf="lib.isValidList(item.children) && item.data.IsMapped">
            <ng-container *ngTemplateOutlet="withChildern; context:{ $implicit: item }"></ng-container>
          </ng-container>
          <ng-container *ngIf="!lib.isValidList(item.children) && item.data.IsMapped">
            <ng-container *ngTemplateOutlet="withoutChildern; context:{ $implicit: item }"></ng-container>
          </ng-container>
        </ng-template>
      </ng-template>
      <ng-template #withChildern let-item>
        <li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{ exact: true }"
          aria-haspopup="true" data-menu-submenu-toggle="hover">
          <a href="#" class="m-menu__link m-menu__toggle">
            <i *ngIf="item.data.ParentSysID > 0" class="m-menu__link-bullet m-menu__link-bullet--dot">
              <span></span>
            </i>
            <i *ngIf="item.data.ParentSysID === 0" class="m-menu__link-icon {{item.data.Icon}}"></i>
            <span class="m-menu__link-text">
              {{item.data.Name}}
            </span>
            <i class="m-menu__ver-arrow la la-angle-right"></i>
          </a>
          <div class="m-menu__submenu">
            <span class="m-menu__arrow"></span>
            <ul class="m-menu__subnav">
              <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item.children }"></ng-container>
            </ul>
          </div>
        </li>
      </ng-template>
      <ng-template #withoutChildern let-item>
        <li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{ exact: true }" aria-haspopup="true">
          <a routerLink="{{item.data.Url}}" class="m-menu__link">
            <i *ngIf="item.data.ParentSysID > 0" class="m-menu__link-bullet m-menu__link-bullet--dot">
              <span></span>
            </i>
            <i *ngIf="item.data.ParentSysID === 0" class="m-menu__link-icon {{item.data.Icon}}"></i>
            <span class="m-menu__link-text">
              {{item.data.Name}}
            </span>
          </a>
        </li>
      </ng-template>
    </ul>
  </div>
  <!-- END: Aside Menu -->
</div>
<!-- END: Left Aside -->



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/app/@layout/nav-aside/nav-aside.component.html